import React from "react";
import { Badge } from "@/components/ui/badge";

const MAP = {
  LEAD: { label: "Lead", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  PROSPECT: { label: "Prospect", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  RE_ENGAGED: { label: "Re-Engaged (VSM)", cls: "bg-violet-50 text-violet-700 border-violet-200" },
  DEAL: { label: "Deal", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  WON: { label: "Won", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  LOST: { label: "Lost", cls: "bg-slate-100 text-slate-500 border-slate-200" },
};

export function StageBadge({ stage, className = "" }) {
  const s = MAP[stage] || MAP.LEAD;
  return (
    <Badge variant="outline" className={`font-semibold ${s.cls} ${className}`} data-testid={`stage-badge-${stage}`}>
      {s.label}
    </Badge>
  );
}
